import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-end gap-2 mt-2" }

import { reactive, watch } from 'vue'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'PasswordValidation',
  props: {
    password: {
      type: String,
      required: true,
    },
    modelValue: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

  const props = __props

  const validationCriteria = reactive({
    uppercase: false,
    lowercase: false,
    hasNumber: false,
    minLength: false,
  })

  const emit = __emit

  watch(
    () => props.password,
    (current) => {
      validationCriteria.lowercase = false
      validationCriteria.uppercase = false
      validationCriteria.hasNumber = false
      validationCriteria.minLength = false
      emit('update:modelValue', false)

      const lowerCaseLetters = /[a-z]/g
      if (current.match(lowerCaseLetters)) {
        validationCriteria.lowercase = true
      }

      const upperCaseLetters = /[A-Z]/g
      if (current.match(upperCaseLetters)) {
        validationCriteria.uppercase = true
      }

      const numbers = /[0-9]/g
      if (current.match(numbers)) {
        validationCriteria.hasNumber = true
      }

      if (current.length >= 8) {
        validationCriteria.minLength = true
      }

      if (
        validationCriteria.uppercase &&
        validationCriteria.lowercase &&
        validationCriteria.hasNumber &&
        validationCriteria.minLength
      ) {
        emit('update:modelValue', true)
      }
    },
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(["circle", [
        validationCriteria.minLength ? 'bg--success' : 'bg--grayscale-light',
      ]])
    }, " +8 ", 2),
    _createElementVNode("span", {
      class: _normalizeClass(["circle", [
        validationCriteria.uppercase ? 'bg--success' : 'bg--grayscale-light',
      ]])
    }, " A ", 2),
    _createElementVNode("span", {
      class: _normalizeClass(["circle", [
        validationCriteria.lowercase ? 'bg--success' : 'bg--grayscale-light',
      ]])
    }, " a ", 2),
    _createElementVNode("span", {
      class: _normalizeClass(["circle", [
        validationCriteria.hasNumber ? 'bg--success' : 'bg--grayscale-light',
      ]])
    }, " 123 ", 2)
  ]))
}
}

})